// extracted by mini-css-extract-plugin
export var activeDot = "_5v-c";
export var buttonContainer = "_5v-9";
export var channelButton = "_5v-a";
export var clickable = "_5v-d";
export var content = "_5v-0";
export var contentFull = "_5v-2";
export var contentThird = "_5v-1";
export var contentWrapper = "_5v-7";
export var description = "_5v-5";
export var heightShort = "_5v-f";
export var image = "_5v-3";
export var imageContainer = "_5v-4";
export var selectButton = "_5v-e";
export var spinnerContainer = "_5v-b";
export var titleContent = "_5v-8";
export var titleWrapper = "_5v-6";